import React from 'react';
import { FaStar } from 'react-icons/fa';
import { useLoaderData } from 'react-router-dom';
import Faq from '../Faq/Faq';
import Pricing from './Pricing/Pricing';

const ServiceDetails = () => {




    const serviceDetails = useLoaderData();

    console.log(serviceDetails);

    const { title, review, advantage, whyChooseMe, clientInfoNeed, serviceStep, slide1, slide2, description, slide3 } = serviceDetails;

    return (
        <div className=''>

            <div className='max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-5 gap-16'>

                {/* left side */}

                <div className='md:col-span-3 '>
                    <h1 className='text-3xl font-semibold'>{title}</h1>
                    <div className='flex gap-5 items-center my-8'>
                        <div className="avatar">
                            <div className="w-10 h-10 rounded-full ring ring-[#2e64ab] ring-offset-2">
                                <img src="https://i.ibb.co/dD7d8Kj/shijan.jpg" />
                            </div>
                        </div>
                        <div>
                            <h2 className='text-md'>Md Shijan Ali</h2>
                        </div>
                        <div className="divider lg:divider-horizontal"></div>
                        <div className='flex items-center gap-2'>
                            <FaStar className='text-[#FFB33E]'></FaStar>
                            <FaStar className='text-[#FFB33E]'></FaStar>
                            <FaStar className='text-[#FFB33E]'></FaStar>
                            <FaStar className='text-[#FFB33E]'></FaStar>
                            <FaStar className='text-[#FFB33E]'></FaStar>
                            <p><span className='text-[#FFB33E]'> 5.0</span> ({review})</p>
                        </div>
                    </div>

                    {/* slider code */}

                    <>
                        <div className="carousel w-full h-[450px]">
                            <div id="slide1" className="carousel-item relative w-full">
                                <img src={slide1 ? slide1 : ''} className="w-full" />
                                <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                                    <a href="#slide1" className="btn btn-circle">❮</a>
                                    <a href="#slide2" className="btn btn-circle">❯</a>
                                </div>
                            </div>
                            <div id="slide2" className="carousel-item relative w-full">
                                <img src={slide2 ? slide2 : ''} className="w-full" />
                                <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                                    <a href="#slide1" className="btn btn-circle">❮</a>
                                    <a href="#slide3" className="btn btn-circle">❯</a>
                                </div>
                            </div>
                            <div id="slide3" className="carousel-item relative w-full">
                                <img src={slide3 ? slide3 : ''} className="w-full" />
                                <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                                    <a href="#slide2" className="btn btn-circle">❮</a>
                                    <a href="#slide1" className="btn btn-circle">❯</a>
                                </div>
                            </div>
                        </div>
                    </>

                    {/* About service */}

                    <>
                        <h1 className='text-2xl font-semibold mt-16'>About This Service</h1>

                        <div className='mt-10'>
                            {
                                description ? description.map(dsc => <p className='text-lg my-5'>{dsc}</p>) : ''
                            }
                        </div>

                        <div>
                            <h3 className='text-xl mt-16'>In this gig you will get from me:-</h3>
                            <ol className='mt-10 ml-5 text-lg list-decimal'>

                                {
                                    serviceStep ? serviceStep.map(stp => <li>{stp}</li>) : ''
                                }
                            </ol>
                        </div>

                        <div>
                            <h3 className='text-xl mt-16'>What information I need from you:-</h3>
                            <ol className='mt-10 ml-5 text-lg list-decimal'>
                                {
                                    clientInfoNeed ? clientInfoNeed.map(clintinfo => <li>{clintinfo}</li>) : ''
                                }
                            </ol>
                        </div>

                        {advantage ? <div>
                            <h3 className='text-xl mt-16'>You will get the following advantages from me:-</h3>
                            <ol className='mt-10 ml-5 text-lg list-decimal'>
                                {advantage ? advantage.map(adv => <li>{adv}</li>) : ''}
                            </ol>
                        </div> : ''
                        }

                        <div>
                            <h3 className='text-xl mt-16'>Why you will choose me:-</h3>
                            <ol className='mt-10 ml-5 text-lg list-decimal'>
                                {
                                    whyChooseMe ? whyChooseMe.map(chosmewhy => <li>{chosmewhy}</li>) : ''
                                }
                            </ol>
                        </div>

                        <p className='text-lg mt-10'>Note: Please feel Free to send me a message before placing an order. Thanks</p>
                    </>


                    {/* FAQ */}
                    <>
                        <div className="divider my-16"></div>
                        <Faq serviceDetails={serviceDetails}></Faq>
                    </>
                </div>

                {/* right side */}

                <div className='md:col-span-2 '>
                    <Pricing serviceDetails={serviceDetails}></Pricing>
                </div>
            </div>
        </div >
    );
};

export default ServiceDetails;